t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_settings')

module.exports = ->
  if !t.mustacheVar('isLoggedIn')
    t.ul '.board-menu-navigation', ->
      t.li '.board-menu-navigation-item', ->
        t.a '.js-change-cookie-settings.board-menu-navigation-item-link', { href: '#' }, =>
          t.icon 'gear', 'cookie-settings', { class: 'board-menu-navigation-item-link-icon' }

    t.hr()

  t.div ->

    t.ul '.pop-over-list.inset', =>

      t.li =>
        t.a { class: 'js-change-org' + t.mustacheBlockInverted('canChangeOrg', (-> ' disabled')), href: '#' }, =>
          t.mustacheBlock 'setOrgNull', =>
            t.format 'remove-from-organization'
          t.mustacheBlockInverted 'setOrgNull', =>
            t.format 'change-organization-ellipsis'
          t.mustacheBlock 'orgDisplayName', =>
            t.span '.sub-name', =>
              t.text t.mustacheVar('orgDisplayName')

      t.hr()

      t.li =>
        t.a { class: t.mustacheBlock('__own', (-> 'js-toggle-covers')) + t.mustacheBlockInverted('__own', (-> ' disabled')), href: '#' }, =>
          t.mustacheBlockInverted 'cardCovers', =>
            t.format 'enable-card-cover-images'
          t.mustacheBlock 'cardCovers', =>
            t.format 'card-cover-images-enabled'
            t.icon 'check'
          t.span '.sub-name', =>
            t.format 'show-images-on-front-of-cards'

      t.hr()

      if !t.mustacheVar('templateModeEnabled')
        t.li =>
          t.a { class: t.mustacheBlock('__own', (-> 'js-change-comments')) + t.mustacheBlockInverted('__own', (-> ' disabled')), href: '#' }, =>
            t.format 'commenting-permissions-ellipsis-commentsdisplay', { commentsDisplay: t.mustacheVar('commentsDisplay') }

      if t.mustacheVar('votingEnabled')
        t.li =>
          t.a { class: t.mustacheBlock('__own', (-> 'js-change-voting')) + t.mustacheBlockInverted('__own', (-> ' disabled')), href: '#' }, =>
            t.format 'voting-permissions-ellipsis-votingdisplay', { votingDisplay: t.mustacheVar('votingDisplay') }

      if !t.mustacheVar('templateModeEnabled')
        t.li =>
          t.a { class: t.mustacheBlock('__own', (-> 'js-change-add-members')) + t.mustacheBlockInverted('__own', (-> ' disabled')), href: '#' }, =>
            t.format 'invitations-permissions-ellipsis-invitationsdisplay', { invitationsDisplay: t.mustacheVar('invitationsDisplay') }

        t.hr()

        t.li =>
          t.a { class: ' ' + t.mustacheBlock('__own', (-> ' js-toggle-org-mem-join ')) + ' ' + t.mustacheBlockInverted('__own', (-> ' disabled ')) + ' ' + t.mustacheBlockInverted('hasOrg', (-> ' disabled ')) + ' ' + t.mustacheBlock('permissionLevel_private', (-> ' disabled ')) + ' ', href: '#' }, =>
            t.check t.mustacheVar('selfJoin_true'), 'allow-team-members-to-edit-and-join'
            t.span '.sub-name', =>
              t.mustacheBlock 'hasOrg', =>
                t.mustacheBlock 'permissionLevel_private', =>
                  t.format 'any-team-member-can-edit-and-join-this-board-to-enable-this-the-board-cant-be-private'
              t.mustacheBlock 'hasOrg', =>
                t.mustacheBlockInverted 'permissionLevel_private', =>
                  t.format 'any-team-member-can-edit-and-join-this-board'
              t.mustacheBlockInverted 'hasOrg', =>
                t.mustacheBlock 'permissionLevel_private', =>
                  t.format 'any-team-member-can-edit-and-join-this-board-to-enable-this-the-board-has-to-be-a-part-of-a-team-and-the-board-cant-be-private'
              t.mustacheBlockInverted 'hasOrg', =>
                t.mustacheBlockInverted 'permissionLevel_private', =>
                  t.format 'any-team-member-can-edit-and-join-this-board-to-enable-this-the-board-has-to-be-a-part-of-a-team'

